import { Component, Input } from '@angular/core';
import { BaseConfirmationDialogComponent } from '../base-confirmation-dialog.component';

@Component({
  selector: 'boi-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent extends BaseConfirmationDialogComponent<void> {
  @Input() hasWarning = true;
  @Input() hasCancelButton = true;
  @Input() isCancelButtonRightSide = false;
  @Input() width = 500;
  @Input() isVoWarningDialog = false;
}
